import { Injectable } from '@angular/core';
import { FilterGroup } from '@vendasta/va-filter2';

@Injectable()
export class FacebookFormsTableFilterService {
  filters: FilterGroup = new FilterGroup('facebook-forms-table');
}
